<template>
  <v-card>
    <v-card-title primary-title>
      <h1>{{ $tr.wagon.title }}</h1> <!-- Suivi du parc wagons -->
    </v-card-title>

    <!-- Boite de dialogue de la liste des wagons -->
    <v-dialog v-model="dialogWagons" persistent :overlay="false" max-width="450px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>
          {{ lieu }} {{ nbj > 0 ? " : présents depuis au moins " + nbj + " jours" : "" }}
        </v-card-title>
        <v-card-text>
          <v-simple-table fixed-header height="300px" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Numéro</th> <!-- Numéro -->
                  <th>Date</th> <!-- Date -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(wagon, indexWagon) in wagons" :key="indexWagon">
                  <td>{{ wagon.wgpNumeroWagon }}</td>
                  <td>{{ computeDate(wagon.wgpDate) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogWagons = false">{{ $tr.dialogCommon.close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text>
    
      <v-progress-linear indeterminate color="teal" v-if="loading"></v-progress-linear>
      <div class="d-flex flew-row" style="flex-wrap: wrap">
      
        <!-- Wagons en circulation -->
        <div style="background-color: #F0F0F0; padding: 10px 20px 10px 20px; margin-right: 20px; margin-bottom: 20px;">
          <div class="d-flex flew-row align-center">
            <h3 style="text-align: left;" class="blue--text darken-3 mt-0 mr-4">Wagons en ciculation</h3>
            <div>{{ dateMiseajour }}</div>
          </div>
          <table>
            <thead>
              <tr>
                <td>Lieu</td>
                <td>En cours</td>
                <td>Depuis {{ nbj1 }} jours</td>
                <td>Depuis {{ nbj2 }} jours</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lieu, indexLieu) in lieux" :key="indexLieu">
                <td class="etiquette">{{computeLieu(lieu.lieu)}}  <span style="font-size: 10px;">{{ lieu.lieu }}</span></td>
                <td>
                  <div class="d-flex flew-row col colOk" style="align-items:center">
                    <div class="valeur">{{ lieu.nbWagonsPresents }}</div>
                    <v-btn x-small text class="" color="green" @click="boutonVoirWagonsLieu(lieu.lieu, 0)"><v-icon>mdi-eye</v-icon></v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex flew-row col colAlert" style="align-items:center">
                    <div class="valeur">{{ lieu.nbWagonsPresentsNj1 }}</div>
                    <v-btn x-small text class="" color="green" @click="boutonVoirWagonsLieu(lieu.lieu, nbj1)"><v-icon>mdi-eye</v-icon></v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex flew-row col colAlarm" style="align-items:center">
                    <div class="valeur">{{ lieu.nbWagonsPresentsNj2 }}</div>
                    <v-btn x-small text class="" color="green" @click="boutonVoirWagonsLieu(lieu.lieu, nbj2)"><v-icon>mdi-eye</v-icon></v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Historique de présence -->
        <div style="background-color: #E1F5FE; padding: 10px 20px 10px 20px; min-width:400px;  margin-right: 20px; margin-bottom: 20px;">
          <div class="d-flex flew-row align-center">
            <h3 style="text-align: left;" class="blue--text darken-3 mt-0 mr-4">Historique de présence des wagons</h3>
          </div>

          <!-- Boutons de sélection -->
          <h-group class="mb-3">
            <!-- Période sur mésure -->
            <div style="width: 150px"><v-text-field hide-details type="date" :label="$tr.dialogCommon.from" v-model="s1dateDebut"></v-text-field></div>
            <div style="width: 150px" class="ml-2"><v-text-field hide-details type="date" :label="$tr.dialogCommon.to" v-model="s1dateFin" @change="saisieDateFinChangeEvent"></v-text-field></div>

            <!-- Période par semaine -->
            <v-group class="ml-5">
              <v-btn color="success" x-small @click="semaineEnCours" :loading="loading">{{ $tr.timeCommon.currentWeek }}</v-btn>
              <h-group class="mt-1" style="justify-content: space-around;">
                <v-btn color="success" x-small @click="semaineMoinsUn" :loading="loading">{{ $tr.timeCommon.weekMinus1 }}</v-btn>
                <v-btn color="success" class="ml-1" x-small @click="semainePlusUn" :loading="loading">{{ $tr.timeCommon.weekPlus1 }}</v-btn>
              </h-group>
            </v-group>

            <!-- Période par mois -->
            <v-group class="ml-5">
              <v-btn color="success" x-small @click="moisEnCours" :loading="loading">{{ $tr.timeCommon.currentMonth }}</v-btn>
              <h-group class="mt-1" style="justify-content: space-around;">
                <v-btn color="success" x-small @click="moisMoinsUn" :loading="loading">{{ $tr.timeCommon.monthMinus1 }}</v-btn>
                <v-btn color="success" class="ml-1" x-small @click="moisPlusUn" :loading="loading">{{ $tr.timeCommon.monthPlus1 }}</v-btn>
              </h-group>
            </v-group>

            <!-- Période par année -->
            <v-group class="ml-5">
              <v-btn color="success" hide-details x-small @click="anneeEnCours" :loading="loading">{{ $tr.timeCommon.currentYear }}</v-btn>
              <h-group class="mt-1" style="justify-content: space-around;">
                <v-btn color="success"  x-small @click="anneeMoinsUn" :loading="loading">{{ $tr.timeCommon.yearMinus1 }}</v-btn>
                <v-btn color="success" class="ml-1"  x-small @click="anneePlusUn" :loading="loading">{{ $tr.timeCommon.yearPlus1 }}</v-btn>
              </h-group>
            </v-group>
            
          </h-group>

          <!-- courbe -->
          <div>
            <canvas ref="chart1"  width="600" height="400"></canvas>
          </div>


        </div>

        <!-- Liste des wagons -->
        <div style="background-color: #80DEEA; padding: 10px 20px 10px 20px; min-width:400px; margin-right: 20px; margin-bottom: 20px; max-height: 900px; overflow: auto;">
          <div class="d-flex flew-row align-center">
            <h3 style="text-align: left;" class="blue--text darken-3 mt-0 mr-4">Liste des wagons</h3>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center;">
            <div style="max-width: 180px;"><v-text-field label="Filtre" v-model="filtreListeWagons" @keyup="filtreWagonsChangeEvent"></v-text-field></div>
            <div style="flex: 1"></div>
            <div class="ml-2">{{ listeWagonsFiltree.length }} wagon{{ listeWagonsFiltree.length > 0 ? 's' : '' }}</div>
            <v-btn color="success" class="ml-3" @click="exporterListeWagonsClick" :disabled="this.listeWagonsFiltree.length <= 0">{{ $tr.dialogCommon.export }}</v-btn>
          </div>
          <table>
            <thead>
              <tr>
                <th rowspan="2">Wagon</th>
                <th rowspan="2">Lieu</th>
                <th rowspan="2">Date</th>
                <th rowspan="2">Evénement</th>
                <th rowspan="2">Groupe</th>
                <th colspan="5" class="thconstat">Dernier constat WR</th>
              </tr>
              <tr>
                <th class="thconstat">Cat.</th>
                <th class="thconstat">Lieu</th>
                <th class="thconstat">Date</th>
                <th class="thconstat">Avarie</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(wagon, indexWagon) in listeWagonsFiltree" :key="indexWagon">
                <td>{{ wagon.wgpNumeroWagon }}</td>
                <td>{{ wagon.wgpLieu }}</td>
                <td>{{ computeDateheure(wagon.wgpDate) }}</td>
                <td>{{ wagon.wgpEvenement }}</td>
                <td>{{ wagon.wgpGroupe }}</td>

                <td :class="computeClassDernierConstat(wagon.constat)">{{ wagon.constat != undefined ? wagon.constat.categorie : '' }}</td>
                <td :class="computeClassDernierConstat(wagon.constat)">{{ wagon.constat != undefined ? wagon.constat.lieu : '' }}</td>
                <td :class="computeClassDernierConstat(wagon.constat)">{{ wagon.constat != undefined ? computeDernierConstatDate(wagon.constat.date) : '' }}</td>
                <td :class="computeClassDernierConstat(wagon.constat)">{{ wagon.constat != undefined ? wagon.constat.labelAvarie : '' }}</td>
              </tr>
            </tbody>
          </table>

        </div>

        <!-- Suivi d'un des wagons -->
        <div style="background-color: #B2DFDB; padding: 10px 20px 10px 20px; min-width:400px; margin-right: 20px; margin-bottom: 20px; max-height: 900px; overflow: auto;">
          <div class="d-flex flew-row align-center">
            <h3 style="text-align: left;" class="blue--text darken-3 mt-0 mr-4">Suivi d'un wagon</h3>
          </div>
          <v-progress-linear indeterminate color="teal" v-if="loadingSuiviWagons"></v-progress-linear>
          <h-group  class="mb-1">
            <div class="mr-3">{{ $tr.wagon.tab2Title }}</div> <!-- Saisir un numéro de wagon<br/>(au moins les 5 derniers chiffres) -->
            <div style="width: 160px;"  class="mr-3">
              <v-text-field label="N° de wagon" v-model="numeroWagonPourSuivi"></v-text-field>
            </div>
            <div style="width: 80px;"  class="mr-5 ml-5">
              <v-text-field type="number" label="Nb de mois" v-model="nbMoisPourSuivi"></v-text-field>
            </div>
            <v-checkbox label="Inclure les rapports d'intervention" v-model="inclureRapportIntervention" :value="true" class="mr-5"></v-checkbox>
            <v-btn color="success" class="mr-5" @click="rechercherSuiviClick">{{ $tr.dialogCommon.search }}</v-btn>
            <v-btn color="success" class="mr-3" @click="exporterSuiviClick" :disabled="this.suiviWagon.length <= 0">{{ $tr.dialogCommon.export }}</v-btn>
          </h-group>
          <v-group class="ml-4">
            <v-simple-table dense fixed-header  height="50%" style="background-color: #F8F8F8;">
              <template v-slot:default>
                <thead>
                <tr>
                  <td>{{ $tr.wagon.tab2c1 }}</td> <!-- Numéro -->
                  <td>{{ $tr.wagon.tab2c2 }}</td> <!-- Source -->
                  <td>{{ $tr.wagon.tab2c3 }}</td> <!-- Date -->
                  <td>{{ $tr.wagon.tab2c4 }}</td> <!-- Lieu -->
                  <td>{{ $tr.wagon.tab2c5 }}</td> <!-- Commentaire -->
                </tr>
              </thead>
              <tbody  >
                <tr v-for="(suivi, indexSuivi) in suiviWagon" :key="indexSuivi">
                  <td>{{ suivi.numero }}</td>
                  <td>{{ suivi.source }}</td>
                  <td>{{ computeDateHeure(suivi.date) }}</td>
                  <td>{{ suivi.lieu }}</td>
                  <td class="text-left" :style="'color: ' + computeCouleurSuiviWagon(suivi.type)">{{ suivi.commentaire }}</td>
                </tr>
              </tbody>

              </template>
            </v-simple-table>

          </v-group>
        </div>

        <!-- Wagons en réforme -->
        <div style="background-color: #E6EE9C; padding: 10px 20px 10px 20px; min-width:400px; margin-right: 20px; margin-bottom: 20px; max-height: 350px; overflow: auto;">
          <div class="d-flex flew-row align-center">
            <h3 style="text-align: left;" class="blue--text darken-3 mt-0 mr-4">Wagons en réforme</h3>
          </div>
          <div><i>A venir sous peu</i></div>

        </div>


      </div>
    </v-card-text>

  </v-card>
</template>

<script>
import axios from 'axios';
import Chart from 'chart.js';
import moment from 'moment';
const { exportJsonToExcel } = window.jsonToExcel;

export default {
  components: {},

  data() {
    return {
      loading: false,
      lieux: [],
      nbj1: 5,
      nbj2: 10,
      dateMiseajour: undefined,
      lieu: "",
      nbj: 0,
      dialogWagons: false,
      wagons: [],
      chartData: {
        labels: [ 'January', 'February', 'March' ],
        datasets: [ { data: [40, 20, 12] } ]
      },
      chartOptions: {
        responsive: true
      },
      dateDebut: new Date(),
      dateFin: new Date(),
      s1dateDebut: "",
      s1dateFin: "",
      historique: [],
      colorArray: [
        "Blue ", "Green", "Red", "Orange", "Violet", "Indigo", "Yellow"
      ],
      listeWagons: [],
      listeWagonsFiltree: [],
      filtreListeWagons: "",
      loadingSuiviWagons: false,
      numeroWagonPourSuivi: "",
      suiviWagon:[],
      inclureRapportIntervention: true,
      nbMoisPourSuivi: 3
    }
  },

  mounted() {
    var url = "/api/liLieus?access_token=" + this.$user.id;
    axios.get(url)
      .then(function(response) {
        this.listeLieux = response.data
        this.lireWagons();
        this.anneeEnCours();
      }.bind(this))
  },

  watch: {
    $route(to) {
      if (to.url.startsWith('/wagons2/')) {
        this.lireWagons()
      }
    }
  },

  methods: {
    async lireWagons() {
      this.loading = true
      await axios.get("/api/wgWagons/nbWagonsPresentsParLieu?groupe=VOSGES&nbj1=" + this.nbj1 + "&nbj2=" + this.nbj2 + "&access_token=" + this.$user.id)
      .then(function (response) {
          this.loading = false
          this.lieux = response.data.lieux
          this.dateMiseajour = response.data.dateMiseajour.replace(/T/g, " ").substr(0, 19)
          this.listeWagons = response.data.wagons
          this.listeWagonsFiltree = response.data.wagons
          this.lireDerniersConstats()
        }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied)
          this.loading = false
        }
        else {
          this.afficherErreur(error.message)
          this.loading = false
        }
      });
    },

    async lireDerniersConstats() {
      this.loading = true
      const url = "https://www.wagonreport.com/api/Constats/derniersConstats?access_token=01LakXGR4Lo0UhEizTYrkPC4qpl8PCXI128978azaevlNTaeKgGJ4lSdHeazEP0301zIVKi"
      this.$axios.get(url, {headers: {'Cache-Control': 'no-cache',  'Pragma': 'no-cache', 'Expires': '0',}})
        .then(function(response) {
          this.derniersConstats = response.data
          this.listeWagonsFiltree.forEach(wagon => {
            const constat = this.derniersConstats.find(w => w.numeroWagon == wagon.wgpNumeroWagon)
            if (constat != undefined) {
              wagon.constat = constat
            }
          })
          this.$forceUpdate()
          this.loading = false
        }.bind(this))
        .catch(function(error) {
          console.log(error)
          this.loading = false
        }.bind(this))
    },

    async boutonVoirWagonsLieu(lieu, nbj) {
      this.loading = true
      this.lieu = lieu
      this.nbj = nbj
      await axios.get("/api/wgWagons/listeWagonsPresentsParLieu?groupe=VOSGES&lieu=" + this.lieu + "&nbj=" + this.nbj + "&access_token=" + this.$user.id)
      .then(function (response) {
          this.loading = false
          this.wagons = response.data
          this.dialogWagons = true
        }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied)
          this.dialogWagons = false
          this.loading = false
        }
        else {
          this.afficherErreur(error.message)
          this.dialogWagons = false
          this.loading = false
        }
      });
    },

    computeDate(date) {
      return date.substr(0, 10)
    },

    computeDateheure(date) {
      return date?.substr(0, 16).replace(/T/g, " ")
    },

    computeLieu(lieu) {
      if (lieu == null) {
        return "en transit ..."
      }
      var l1 = this.listeLieux.find(l => l.liCode == lieu)
      return l1 != undefined ? l1.liDesignation : lieu
    },

    genererGraphique() {
      if (this.chart1 == null) {
        this.chart1 = new Chart(this.$refs.chart1, {
          type: 'line',
          data: {
            labels: ["2026-03-20", "2026-03-21", "2026-03-23"],
            datasets: [{
            label: "MERREY",
            data: [12,36,24],
            type: 'line',
            borderWidth: 1,
            borderColor: '#FF8000',
            backgroundColor: '#FFFFFF',
            fill: false
          }              
            ]
          },
          options: {
            scales: {
              yAxes: [
              {
                id: 'nb',
                type: 'linear',
                position: 'left',
                ticks: {beginAtZero: true}
              }
            ]}
          }
        });
      }
      const labels = []
      const datasets = []

      // Repérage des dates
      var idxColor = 0
      for (var idx = 0; idx < this.historique.length; idx++) {
        const row = this.historique[idx]
        const date = row.nweDate.substr(0,10)
        if (labels.indexOf(date) < 0) {
          labels.push(date)
        }
        var dataset = datasets.find(ds => ds.label == row.nweLieu)
        if (dataset == undefined) {
          dataset = {
            label: row.nweLieu,
            data: [],
            type: 'line',
            borderWidth: 1,
            borderColor: this.colorArray[idxColor],
            //backgroundColor: '#FFFFFF',
            fill: false
          }
          idxColor++
          datasets.push(dataset)
        }
        dataset.data.push(row.nweNbWagons)
      }
      this.chart1.data.labels = labels
      this.chart1.data.datasets = datasets
      this.chart1.update();
    },

    mettreAJourDates() {
      this.s1dateDebut = moment(this.dateDebut).format("YYYY-MM-DD")
      this.s1dateFin = moment(this.dateFin).format("YYYY-MM-DD")
    },

    semaineEnCours() {
      const lundi = new Date()
      lundi.setDate(lundi.getDate() - (lundi.getDay() + 6) % 7);
      this.dateDebut = lundi
      this.dateFin = new Date().setDate(lundi.getDate() + 7)
      this.lireHistorique()
    },

    semaineMoinsUn() {
      this.dateDebut = this.moment(this.dateDebut).subtract(1, 'weeks')
      this.dateFin = this.moment(this.dateFin).subtract(1, 'weeks')
      this.lireHistorique()
    },

    semainePlusUn() {
      this.dateDebut = this.moment(this.dateDebut).add(1, 'weeks')
      this.dateFin = this.moment(this.dateFin).add(1, 'weeks')
      this.lireHistorique()
    },


    moisEnCours() {
      const now = new Date()
      const d0 = 1
      const m0 = now.getMonth()
      const y0 = now.getFullYear()
      const d1 = 1
      const m1 = m0 == 11 ? 0 : m0 + 1
      const y1 = m0 == 11 ? y0 + 1 : y0
      this.dateDebut = new Date(y0, m0, d0)
      this.dateFin = new Date(y1, m1, d1)
      this.lireHistorique()
    },


    moisMoinsUn() {
      this.dateDebut = this.moment(this.dateDebut).subtract(1, 'months')
      this.dateFin = this.moment(this.dateFin).subtract(1, 'months')
      this.lireHistorique()
    },

    moisPlusUn() {
      this.dateDebut = this.moment(this.dateDebut).add(1, 'months')
      this.dateFin = this.moment(this.dateFin).add(1, 'months')
      this.lireHistorique()
    },

    anneeEnCours() {
      const now = new Date()
      const d0 = 1
      const m0 = 0
      const y0 = now.getFullYear()
      const d1 = 1
      const m1 = 0
      const y1 = y0 + 1
      this.dateDebut = new Date(y0, m0, d0)
      this.dateFin = new Date(y1, m1, d1)
      this.lireHistorique()
    },

    anneePlusUn() {
      this.dateDebut = this.moment(this.dateDebut).add(1, 'years')
      this.dateFin = this.moment(this.dateFin).add(1, 'years')
      this.lireHistorique()
    },

    anneeMoinsUn() {
      this.dateDebut = this.moment(this.dateDebut).subtract(1, 'years')
      this.dateFin = this.moment(this.dateFin).subtract(1, 'years')
      this.lireHistorique()
    },

    saisieDateFinChangeEvent() {
      this.dateDebut = new Date(this.s1dateDebut)
      this.dateFin = new Date(this.s1dateFin)
      this.lireHistorique()
    },

    async lireHistorique() {
      this.mettreAJourDates()
      const date1 = this.moment(this.dateDebut).format("YYYY-MM-DD")
      const date2 = this.moment(this.dateFin).format("YYYY-MM-DD")
      await axios.get("/api/wgWagons/nbWagonsPresentsPeriode?date1=" + date1 + "&date2=" + date2 + "&access_token=" + this.$user.id)
      .then(function (response) {
          this.loading = false
          this.historique = response.data
          this.genererGraphique()
        }.bind(this))
      .catch(error => {
        if (error.response.status == 401) {
          // Erreur "accès refusé", redirection vers la page de connexion
          this.afficherErreur(this.$tr.errorCommon.accessDenied)
          this.loading = false
        }
        else {
          this.afficherErreur(error.message)
          this.loading = false
        }
      });

    },

    filtreWagonsChangeEvent() {
      console.log("liste complète", this.listeWagons.length)
      const filtre = this.filtreListeWagons.trim().toUpperCase()
      if (filtre == "") {
        this.listeWagonsFiltree = this.listeWagons
        return
      }
      const liste = this.listeWagons.filter(w => (w.wgpNumeroWagon.indexOf(filtre) >= 0) || (w.wgpLieu?.toUpperCase().indexOf(filtre) >= 0) || (w.constat?.categorie.toUpperCase().indexOf(filtre) >= 0)) 
      console.log("liste", liste.length)
      this.listeWagonsFiltree =  liste
    },
    
    async rechercherSuiviClick() {
      const numwagon = this.numeroWagonPourSuivi.replace(/ /g, "").replace(/-/g, "")
      if (numwagon.length < 5) {
        return
      }
      this.suiviWagon = []
      this.loadingSuiviWagons = true
      try {
        // Chargement des trajets
        var response = await axios.get("/api/wgWagons/suiviWagon?numero=" + numwagon + "&nbMois=" + this.nbMoisPourSuivi + "&access_token=" + this.$user.id)
        const suiviWagon = []
        for(var idx = 0; idx < response.data.length; idx++) {
          const suivi = response.data[idx]
          suiviWagon.push({ numero: suivi.wgNumero, source: "WD", date: suivi.frDepartDateReelle != null ? suivi.frDepartDateReelle : suivi.frDepartDateTheorique, lieu: suivi.frDepartLieu, commentaire: "Départ", type: 0 })
          suiviWagon.push({ numero: suivi.wgNumero, source: "WD", date: suivi.frArriveeDateReelle != null ? suivi.frArriveeDateReelle : suivi.frArriveeDateTheorique, lieu: suivi.frArriveeLieu, commentaire: "Arrivée", type: 0 })
        }
        if (suiviWagon.length > 0) {
          // Chargement des constats
          response = await axios.get("/api/wgWagons/constatswr?numeroWagon=" + suiviWagon[0].numero + "&nbMois=" + this.nbMoisPourSuivi + "&access_token=" + this.$user.id)
          for(idx = 0; idx < response.data.length; idx++) {
            const constat = response.data[idx]
            suiviWagon.push({ numero: constat.numeroWagon.replace(/ /g,'').replace(/-/g, ''), source: "WR Constat", date: constat.date, lieu: constat.lieu + " " + constat.categorie, commentaire: (constat.typeConstat.toLowerCase() == "avaries") ? "Avarie : " + constat.numeroAvarie + " - " + constat.labelAvarie : "Constat " + constat.typeConstat, type: (constat.typeConstat.toLowerCase() == "avaries") ? 2 : 1})
          }
          this.suiviWagon = suiviWagon.sort((a, b) => new Date(b.date) - new Date(a.date));

          // Chargement des rapports d'intervention
          if (this.inclureRapportIntervention) {
            response = await axios.get("/api/wgWagons/rapportswr?numeroWagon=" + suiviWagon[0].numero + "&nbMois=" + this.nbMoisPourSuivi + "&access_token=" + this.$user.id)
            for(idx = 0; idx < response.data.length; idx++) {
              const rapport = response.data[idx]
              for(var idx2 = 0; idx2 < rapport.constatrapport.length; idx2++) {
                const constatrapport = rapport.constatrapport[idx2]
                const date = rapport.date.substr(0,10) + " 22:00:00"
                suiviWagon.push({ numero: rapport.numeroWagon.replace(/ /g,'').replace(/-/g, ''), source: "WR Pool", date: date, lieu: rapport.lieu, commentaire: "Rapport : "+ constatrapport.CRI_Label + " : " + constatrapport.CRI_Total + " €", type: 3 })
              }
            }
          }
          this.suiviWagon = suiviWagon.sort((a, b) => new Date(b.date) - new Date(a.date));
        }
        else {
          this.suiviWagon = suiviWagon
        }
        this.loadingSuiviWagons = false
      }
      catch(error) {
        this.loadingSuiviWagons = false
        console.error(error)
        this.suiviWagon = [];
      }
    },

    computeCouleurSuiviWagon(type) {
      switch(type) {
        case 0: return 'blue'
        case 1: return 'green'
        case 2: return 'red'
        case 3: return '#FF8000'
      }
      return 'black'
    },

    exporterSuiviClick() {
      if (this.suiviWagon.length > 0) {
        const suiviWagonExcel = [['Wagon', 'Source', 'Date', 'Lieu', 'Commentaire']]
        for(var idx = 0; idx < this.suiviWagon.length; idx++) {
          const suivi = this.suiviWagon[idx]
          suiviWagonExcel.push([
            suivi.numero.toString(),
            suivi.source,
            suivi.date != undefined ? suivi.date.replace(/T/g, " ").replace(/.000Z/g, "").replace(/-/g, "/") : "",
            suivi.lieu,
            suivi.commentaire
          ])
        }
        const numwagon = this.suiviWagon[0].numero
        exportJsonToExcel(
          "suivi-wagon-" + numwagon + ".xlsx",
          [
            {
              sheetName: "Suivi",
              data: suiviWagonExcel,
              formatAsTable: false
            }
          ],
          {
            beforeSave: function(workbook) {
              workbook.getWorksheet(1).eachRow(function(row, rowNumber) {
                if (rowNumber > 1) {
                  console.log('Row ' + rowNumber + ' = ' + JSON.stringify(row.values));
                  row.getCell(5).alignment = { vertical: 'middle', horizontal: 'left' }
                  var color = 'FF000000'
                  const type = this.suiviWagon[rowNumber - 2].type
                  if (type == 0) color ='FF0000FF'
                  if (type == 1) color ='FF008000'
                  if (type == 2) color ='FFFF0000'
                  if (type == 3) color ='FFFF8000'
                  console.log(color);
                  row.getCell(5).font = { 'color': {'argb': color} }
                }
              }.bind(this))
            }.bind(this)
          }
        )
        //this.$exporterCsv(suiviWagonExcel, "suivi-wagon-" + numwagon + ".csv")
      }
    },

    exporterListeWagonsClick() {
      if (this.listeWagonsFiltree.length > 0) {
        const listeWagonsExcel = [['Wagon', 'Lieu', 'Date', 'Evénement', 'Groupe', 'Constat cat.', 'Constat lieu', 'Constat date', 'Constat avarie']]
        for(var idx = 0; idx < this.listeWagonsFiltree.length; idx++) {
          const wagon = this.listeWagonsFiltree[idx]
          listeWagonsExcel.push([
            wagon.wgpNumeroWagon.toString(),
            wagon.wgpLieu != null ? wagon.wgpLieu : "",
            wagon.wgpDate != undefined ? wagon.wgpDate.replace(/T/g, " ").replace(/.000Z/g, "").replace(/-/g, "/") : "",
            wagon.wgpEvenement != null ? wagon.wgpEvenement : "",
            wagon.wgpGroupe,
            this.computeDernierConstatChamp(wagon.constat, "categorie"),
            this.computeDernierConstatChamp(wagon.constat, "lieu"),
            this.computeDernierConstatChamp(wagon.constat, "date"),
            this.computeDernierConstatChamp(wagon.constat, "labelAvarie")
          ])
        }
        exportJsonToExcel(
          "liste-wagons-" + moment().format("YYYY-MM-DD_HH:mm:ss") + ".xlsx",
          [
            {
              sheetName: "Liste wagons",
              data: listeWagonsExcel, //.sort((a,b) => (a.wgpDate > b.wgpDate) ? 1 : ((b.wgpDate > a.wgpDate) ? -1 : 0)),
              formatAsTable: false
            }
          ],
          {
            beforeSave: function(workbook) {
              const now = moment();
              workbook.getWorksheet(1).eachRow(function(row, rowNumber) {
                if (rowNumber > 1) {
                  //console.log('Row ' + rowNumber + ' = ' + JSON.stringify(row.values));
                  row.getCell(5).alignment = { vertical: 'middle', horizontal: 'left' }
                  var color = 'FF000000'
                  const date = row.getCell(3).value //listeWagonsExcel[rowNumber - 2][2]
                  if ((date != undefined) && (date != null) && (date != ""))
                  {
                    const vdate = moment(date)
                    const duree  = now.diff(vdate, 'days')
                    if (duree >= 15) {
                      color = 'FFFF0000'
                    }
                    else if (duree >= 8) {
                      color = 'FFFF8000'
                    }
                    else {
                      color = 'FF008000'
                    }
                    console.log(date, duree, color )
                  }
                  //console.log(color);
                  row.getCell(1).font = { 'color': {'argb': color} }
                }
              }.bind(this))
            }.bind(this)
          }
        )
        //this.$exporterCsv(suiviWagonExcel, "suivi-wagon-" + numwagon + ".csv")
      }
    },

    computeDateHeure(date) {
      return date != undefined ?  date.substr(0, 16).replace(/T/g, ' ') : ""
    },

    computeClassDernierConstat(constat) {
      if (constat != undefined) {
        if ((constat.labelAvarie != undefined) && (constat.labelAvarie != ''))
          return "avarie"
      }
      return "pasavarie"
    },

    computeDernierConstatDate(date) {
      if ((date != undefined) && (date?.length != undefined)) {
        return date.substr(0, 16)
      }
      return ""
    },

    computeDernierConstatChamp(constat, champ) {
      if ((constat == undefined) || (constat == null)) {
        return ''
      }
      if ((constat[champ] == undefined) || (constat[champ] == null)) {
        return ''
      }
      return constat[champ].toString()
    }

  }
}
</script>

<style scoped>

.avarie {
  color: red;
  text-align: left;
}

.pasavarie {
  color: #3e7840;
  text-align: left;
}

.valeur {
  background-color: black;
  color: yellow;
  padding: 3px;
  margin: 1px;
  width: 60px;
  margin-right: 0px;
}

.col {
  padding: 5px;
  margin: 1px;
}
.colOk {
  background-color: #A5D6A7;
}
.colAlert {
  background-color: #FFCC80;
}
.colAlarm {
  background-color: #EF9A9A;
}

.etiquette {
  width: 200px;
  text-align: right;
  padding-right: 10px;
}

table, th, td {
  border: 1px solid black !important;
  margin: 10px;
  padding: 5px;
  border-collapse: collapse;
}

th {
  background-color: cadetblue !important;
  color: white !important;
  text-align: center !important;
}

.thconstat {
  background-color: rgb(79, 110, 119) !important;
  color: white !important;
  text-align: center !important;
}

</style>